// routes.js
export default [
  {
    path: '/posts',
    name: 'posts.index',
    component: () => import('@/views/posts/PostsIndex.vue'),
    meta: { 
      requiresAuth: true, 
      permission: 'posts.manage', 
      title: 'posts.indexTitle' 
    },
    children: [
      {
        path: '/posts/create',
        name: 'posts.create',
        component: () => import('@/views/posts/PostCreate.vue'),
        meta: { 
          requiresAuth: true, 
          permission: 'posts.manage', 
          title: 'posts.addTitle' 
        }
      },
      {
        path: '/posts/:id/edit',
        name: 'posts.edit',
        component: () => import('@/views/posts/PostEdit.vue'),
        meta: { 
          requiresAuth: true, 
          permission: 'posts.manage', 
          title: 'posts.editTitle' 
        }
      },
      {
        path: '/posts/:id',
        name: 'posts.show',
        component: () => import('@/views/posts/PostShow.vue'),
        meta: { 
          requiresAuth: true, 
          title: 'posts.showTitle' 
        }
      }
    ] 
  }
]